export const agentRequests = {
  page: {
    filters: {
      accommodation: "Alloggio",
      type: "Tipo",
    },
    subtitle: "Quello che i tuoi ospiti hanno chiesto tramite l'agente.",
    clearFilters: "Rimuovi filtri",
    loadMore: "Mostra altro",
    empty: "Ancora nessuna richiesta.",
    emptyFiltered: "Nessuna richiesta con questi filtri.",
    columns: {
      type: "Tipo",
      guest: "Ospite",
      asks: "Richiesta",
      channel: "Canale",
      status: "Stato",
      when: "Quando",
      amount: "Importo",
    },
  },
  // La columna Importe: en qué quedó el cobro de cada solicitud.
  amount: {
    paid: "Pagato",
    awaiting: "In attesa di pagamento",
    property: "Da pagare in struttura",
    void: "Non addebitato",
    quote: "Offerto",
  },
  common: {
    title: "Richieste della reception IA",
  },
  widget: {
    iaBadge: "IA",
    subtitle: "Ciò che i tuoi ospiti hanno richiesto tramite l'agente.",
    todayOn: "Mostra solo quelle di oggi",
    todayOff: "Mostra solo le richieste di oggi",
    today: "Oggi",
    entersToday: "Arriva oggi",
    entersTodayTitle: "Questa prenotazione arriva oggi",
    test: "test",
    approve: "Approva",
    otherTime: "Un altro orario",
    prioritize: "Dai priorità",
    reject: "Rifiuta",
    dismiss: "Rimuovi dal pannello",
    loading: "Caricamento delle richieste…",
    empty: "Ancora nessuna richiesta.",
    emptySub: "Quando un ospite richiede un check-out posticipato, un check-in anticipato o notti extra, comparirà qui.",
    viewAll: "Vedi tutte le richieste",
    entryTime: "Orario del check-in",
    cancel: "Annulla",
    rejectIrreversible: "Questa azione non può essere annullata.",
    modal: {
      approveTitle: "Approvare la richiesta?",
      approveTimeTitle: "Approvare in un altro orario?",
      tentativeTitle: "Dare priorità a questo arrivo?",
      rejectTitle: "Rifiutare la richiesta?",
      defaultTitle: "Confermare?",
      approveText: "Stai per approvare il check-in anticipato per",
      approveTimeText: "Confermerai il check-in all'orario che imposti per",
      tentativeText: "Gli diremo che farete il possibile per averlo pronto a quell'ora, anche se dipende dalla partenza precedente e dalle pulizie. Verrà inviato a",
      rejectText: "Stai per rifiutare il check-in anticipato per",
      defaultText: "Conferma per",
      approveCta: "Sì, approva",
      approveTimeCta: "Conferma orario",
      tentativeCta: "Sì, avvisa",
      rejectCta: "Sì, rifiuta",
      defaultCta: "Conferma",
    },
  },
  drawer: {
    close: "Chiudi",
    allAccommodations: "Tutti gli alloggi",
    allTypes: "Tutti i tipi",
    today: "Oggi",
    yesterday: "Ieri",
    from: "Da",
    to: "A",
    clear: "Cancella",
    writeWhatsapp: "Scrivi su WhatsApp",
    noMessages: "Nessun messaggio salvato per questa chat.",
    pause: "Pausa",
    play: "Riproduci",
    downloadMp3: "Scarica MP3",
    viewReservation: "Vedi prenotazione",
    loading: "Caricamento…",
    emptyFiltered: "Nessuna richiesta corrisponde a questi filtri.",
    end: "Nessun'altra richiesta.",
    features: {
      early: "Check-in anticipato",
      late: "Check-out posticipato",
      extend: "Prolunga il soggiorno",
      invoice: "Fattura",
      handoff: "Azione richiesta",
      callMessage: "Messaggi di chiamata",
    },
    channels: {
      call: "Chiamata",
    },
  },
  box: {
    rooms: "{count} stanza | {count} stanze",
    nights: "{count} notte | {count} notti",
    guests: "{count} ospite | {count} ospiti",
    earlyRequestedTitle: "Check-in anticipato richiesto",
    arrivalRequestedTitle: "Orario di arrivo richiesto",
    early: "Anticipato",
    arrives: "Arriva",
  },
};
